import { Button, Tooltip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { ReactComponent as FilterAltOffOutlined } from '_icons/filterAltOffOutlined.svg'
import { hasActiveFiltersSelector } from '../store/filters/hasActiveFiltersSelector'
import { newProjectActions } from '../store/newProjectReducer'

export const RemoveFiltersIcon = ({
  variant = 'Icon',
  onFiltersRemoved,
}: {
  variant?: 'Icon' | 'Button'
  onFiltersRemoved?: () => void
}) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const hasActiveFilters = useAppSelector(hasActiveFiltersSelector(false))

  if (!hasActiveFilters) {
    return null
  }

  function removeAllFilters() {
    dispatch(newProjectActions.removeAllFilters())
    onFiltersRemoved && onFiltersRemoved()
  }

  if (variant === 'Button') {
    return (
      <Button variant="outlined" onClick={removeAllFilters}>
        {t('project:remove-filters')}
      </Button>
    )
  } else {
    return (
      <Tooltip title={t('project:remove-filters')}>
        <Button
          size="small"
          onClick={removeAllFilters}
          color="primary"
          variant="outlined"
          style={{
            // padding: 0,
            minWidth: 0,
            width: '28px',
            height: '28px',
            borderRadius: '50%',
          }}
        >
          <FilterAltOffOutlined />
        </Button>
      </Tooltip>
    )
  }
}
